module.exports = __webpack_public_path__ + "img/scene-icon-4.1e720a37.png";